import { TicketAutorizacionTransporteService } from './../../services/ticket-autorizacion-transporte.service';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { moduloGaritas } from '../../diccionarios/balanzaModulo.js';
import { UtilsService } from './../../../../shared/utils/utils.service';
import { LfsaBotonEditarGridComponent} from './../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import * as printJS from 'print-js';
import { formatDate } from '@angular/common';
import { ProveedorService } from './../../services/proveedor.service';
import { PlacaService } from './../../services/placa-transportista.service';
import { CedulaChoferService } from '../../services/cedula-chofer.service';
import { UsuarioBasculaGaritaService } from '../../services/usuario-bascula-garita.service';
import { MantenimientoGaritasService } from '../../services/mantenimiento-garitas.service';
import { LfsaBotonsGridComponent } from 'src/app/shared/components/lfsa-botons-grid/lfsa-botons-grid.component';
import { TanqueroService } from '../../services/tanquero.service';
import { event } from 'jquery';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-ticket-autorizacion-transporte',
  templateUrl: './ticket-autorizacion-transporte.component.html',
  styleUrls: ['./ticket-autorizacion-transporte.component.scss'],
})
export class TicketAutorizacionTransporteComponent implements OnInit {
  public loading: boolean = false;

  public DAT_TITULOS: any = moduloGaritas.titulos.ticketAutorizacionTransporte;
  public DAT_BTNS: any = moduloGaritas.button.buttonsNombre;
  public DAT_BTNCSS: any = moduloGaritas.button.buttonsCss;
  public DAT_MSG: any = moduloGaritas.mensajes;
  public tituloModal: string;

  public DAT_AG_GRID: any = moduloGaritas.agGrid;

  public columnDefs: any[] = [];
  public rowData: any[] = [];
  public gridApi: any;
  public gridColumnApi: any;
  public frameworkComponents: any;
  public isCreated: boolean;
  public estadoSeleccionado: any = 1; 

  public ticketAutorizacionTransporteForm = new FormGroup({
    nroAutorizacionTransporte : new FormControl(''),
    idTipoOrd                 : new FormControl('', [Validators.required]),
    garitaAsignada            : new FormControl('', [Validators.required]),
    garitaAsignadaDescripcion : new FormControl('', [Validators.required]),
    fecha           : new FormControl(new Date(), Validators.required),
    proveedorId     : new FormControl('', []),
    proveedor       : new FormControl('', [Validators.maxLength(20)]),
    detalleProveedor: new FormControl('',),

    placa           : new FormControl('', [Validators.required]),
    placaTransportistaDetalle: new FormControl(''),
    vehiculo        : new FormControl(''),
    marca           : new FormControl(''),
    modelo          : new FormControl(''),

    cedula             : new FormControl('', [Validators.required]),
    chofer             : new FormControl('',),
    referenciaContenido: new FormControl('', [Validators.maxLength(50)]),
    observaciones      : new FormControl('', [Validators.maxLength(300)]),

    proveedorTranspId : new FormControl('', [Validators.required]),
    proveedorTransp   : new FormControl('', [Validators.required, Validators.maxLength(13)]),
    detProveedorTransporte : new FormControl('', [Validators.required]),
    sellos            : new FormControl('', [Validators.maxLength(105), Validators.pattern(/^[a-zA-Z0-9\d-]+$/)]),
    cliente           : new FormControl('', [Validators.maxLength(10)]),
    clienteDetalle    : new FormControl('', []),
    peso              : new FormControl('', [Validators.pattern(/^(?!0\d|$)\d*(\.\d{1,3})?$/)]),
    celular           : new FormControl('', []),
    estadoControlEntrada : new FormControl(),
    pesoBrutoRecibido    : new FormControl(),
    referenciaProducto   : new FormControl(),
    facturaGuia          : new FormControl(),
    lugarSalida          : new FormControl(),
    lugarLlegada         : new FormControl(),
    tanqueros            : new FormControl(),
    ordenFlete           : new FormControl(),

    tanqueroId           : new FormControl(),
    usuario              : new FormControl(localStorage.getItem('userName')),
    authOrigenId         : new FormControl(),
    fechaLlegada         : new FormControl(),
   });
   
  proveedorTransporteInvalido = false;
  modoFormulario = "New";

  constructor(
    private _util: UtilsService,
    private ticketAutorizacionTransporteS: TicketAutorizacionTransporteService,
    private proveedorS            : ProveedorService,
    private placaS                : PlacaService,
    private cedulaChoferS         : CedulaChoferService,
    private usuarioBasculaGaritaS : UsuarioBasculaGaritaService,
    private mantenimientoGaritasS : MantenimientoGaritasService,
    private tanqueroServices      : TanqueroService,
    private dmaestrosServices     : DatosMaestrosService
  ) {
  }

  get proveeTransporteRuc() {
    return this.ticketAutorizacionTransporteForm.get('proveedorTransp');
  }

  get providerTransp(){
    return this.ticketAutorizacionTransporteForm.get('proveedorTranspId');
  }

  get tipoOrden(){
    return this.ticketAutorizacionTransporteForm.get('idTipoOrd');
  }


  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer    : LfsaBotonEditarGridComponent,
      iconButtonRenderer: LfsaBotonsGridComponent
    };
    
    this.columnDefs = [];
    
    if(this.estadoSeleccionado == 1){
      this.columnDefs.push({
        headerName  : 'Registrar salida',
        cellRenderer: 'iconButtonRenderer',
        width       : 140,
        pinned      : 'left',
        suppressSizeToFit: true,
        cellRendererParams: {
          onClick   : this.cambiarEstado.bind(this),
          label     : this.DAT_BTNS.editar ,
          colorBoton: this.DAT_BTNCSS.warning ,
          iconBtn   : 'fas fa-truck',
          tooltipMensaje: 'REGISTRAR SALIDA'
        }
      });
    }

    this.columnDefs.push(
      { headerName: 'Ticket',   field: 'idAuthTransp', sortable: true, filter: true, suppressSizeToFit: true},
      { headerName: 'Fecha',    field: 'fecha', sortable: true, filter: true, suppressSizeToFit: true,
        cellRenderer: (data) => { return data.value ? formatDate(new Date(data.value), 'dd-MM-yyyy HH:mm', 'en') : '' }
      },
      { headerName: 'Estado',   field: 'estadoControlEntradaDesc', suppressSizeToFit: true, sortable: true, filter: true},
      { headerName: 'Proveedor',field: 'proveedor', sortable: true, filter: true, suppressSizeToFit: true, resizable: true},
      { headerName: 'Cliente',  field: 'cliente', sortable: true, filter: true, suppressSizeToFit: true, resizable: true},
      { headerName: 'Garita',   field: 'idGarita.desca', sortable: true, filter: true, suppressSizeToFit: true, resizable: true},
      { headerName: 'Placa',    field: 'placa', suppressSizeToFit: true, sortable: true, filter: true},
      {
        headerName: 'Tipo',
        field: 'idTipoOrd',
        sortable: true,
        suppressSizeToFit: true,
        filter: true,
        valueGetter: function (params) {
          return (params.data.idTipoOrd == 1) ? 'Contratado' : params.data.idTipoOrd == 2 ? "Vehículo Propio" : params.data.idTipoOrd == 3 ? "Ocasional" : "Importaciones";
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        cellStyle: {padding: 0},
        width: 90,
        pinned: 'right',
        cellRendererParams: {
          onClick: this.editarTicket.bind(this),
          label: 'Editar',
          colorBoton: this.DAT_BTNCSS.info,
        },
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        cellStyle: {padding: 0},
        width: 90,
        pinned: 'right',
        cellRendererParams: {
          onClick: this.imprimirTicket.bind(this),
          label: this.DAT_BTNS.imprimir,
          colorBoton: this.DAT_BTNCSS.info,
        }
      }
    );
    
    if(this.estadoSeleccionado == 1){
      this.columnDefs.push({
        headerName  : '',
        cellRenderer: 'buttonRenderer',
        cellStyle   : {padding: 0},
        width       : 90,
        pinned      : 'right',
        cellRendererParams: {
          onClick: this.eliminarTicket.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger,
        }
      });
    }

  }

  cambiarEstado(rowData) {
    // if (this.ticketAutorizacionTransporteForm.invalid) return;
    
    let data = rowData.rowData;    
    
    this.ticketAutorizacionTransporteS.obtenerPorId(data.idAuthTransp).subscribe(
        respTicket => {
          data.proveedor = respTicket.proveedor;
        }, error =>{
        this.loading = false;
        this._util.mensajeErroToast('No se puede actualizar');
      });


    if (data.estadoControlEntrada) {
      this.loading = true;
      data.estadoControlEntrada = data.estadoControlEntrada == 1 ? 0 : 1;

      data.fechaSalida = formatDate(new Date(), 'yyyy-MM-dd', 'en') + "T" + formatDate(new Date(), 'HH:mm:ss', 'en');
      data.pesoBrutoRecibido = data.pesoBrutoRecibido ? data.pesoBrutoRecibido : 0;
      data.estado = "ACTIVO";

      console.log("data salida vehculo", data)

      this._util
        .confirmarSincronoPromesa({
          title: "¿Esta seguro que desea realizar la salida del vehículo?",
          text: 'SALIDA TICKET ' + data.idAuthTransp,
          action: this.DAT_BTNS.editar,
          funcion: this.ticketAutorizacionTransporteS.editar(data),
        })
        .then(() => {
          //this.obtenerTicketAutorizacionTransporte();
          this.onChangeFiltros(1);
          this.loading = false;
          this.closeModal();
        })
        .catch(() => {
          data.estadoControlEntrada = 1;
          this.loading = false;
        });
    }else {
      this._util.mensajeOKToast('Ya se registró la salida del transporte.');
    }
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();
  }

  ngOnInit(): void {
    this.ticketAutorizacionTransporteForm.get('nroAutorizacionTransporte')?.disable({ onlySelf: true });
    this.ticketAutorizacionTransporteForm.get('fecha')?.disable({ onlySelf: true });
    this.ticketAutorizacionTransporteForm.get('proveedorTransp').disable();
    this.ticketAutorizacionTransporteForm.get('usuario')?.disable();
    
    this.girdComponent();
    //this.obtenerTicketAutorizacionTransporte();
    this.obtenerTanqueros();
    this.onChangeFiltros(1);

    //Ticket N#1873 - Bloquea cliente o proveedor
    this.ticketAutorizacionTransporteForm.get('cliente').valueChanges.subscribe((valor) =>{
      if(valor != null && valor.length > 1){
        console.log(valor);
        this.ticketAutorizacionTransporteForm.get('proveedor').disable();
      }});

    this.ticketAutorizacionTransporteForm.get('proveedor').valueChanges.subscribe((valor) =>{
      if(valor != null && valor.length > 1){
        console.log(valor);
        this.ticketAutorizacionTransporteForm.get('cliente').disable();
      }
    });

    this.ticketAutorizacionTransporteForm.get('tanqueros').valueChanges.subscribe((resp) => {
      this.resetCampos();
      this.ticketAutorizacionTransporteForm.get('tanqueroId').reset();
      
      if(resp){
        console.log('tanquero seleccionado =====>', resp);
        let tanqueroSelected = this.tanquerosList.filter(item => item["idTanquero"] == resp);
        /*this.tanqueroServices.obtenerPorId(resp).subscribe(
          respTanquero => {
            if (respTanquero){
              this.ticketAutorizacionTransporteForm.get('proveedorTranspId').setValue(respTanquero.proveedor);
              }
            });
        */
        
        this.ticketAutorizacionTransporteForm.get('proveedorTranspId').setValue(tanqueroSelected[0].proveedor);
        this.ticketAutorizacionTransporteForm.get('placa').setValue(tanqueroSelected[0].placa);
        this.ticketAutorizacionTransporteForm.get('cedula').setValue(tanqueroSelected[0].cedula);
        this.ticketAutorizacionTransporteForm.get('referenciaProducto').setValue(tanqueroSelected[0].referenciaProducto);
        this.ticketAutorizacionTransporteForm.get('lugarSalida').setValue(tanqueroSelected[0].lugarSalida);
        this.ticketAutorizacionTransporteForm.get('lugarLlegada').setValue(tanqueroSelected[0].lugarLlegada);
        this.ticketAutorizacionTransporteForm.get('tanqueroId').setValue(tanqueroSelected[0].idTanquero);

        this.buscarCedulaChofer();
        this.buscarPlacaTransporte();
        //this.onChangeProveedorTransporte(Event);

      }
    });

  }

  usuarioBasculaGarita() {
    let username = localStorage.getItem('userName');
    this.usuarioBasculaGaritaS.obtenerPorUsuario(username, "garita").subscribe(
      resp => {
        if (resp.garita) {
          this.obtenerPorId(resp.garita);
          return;
        }
        this._util.mensajeErroToast('No tiene una garita asignada.');
      },
      error => {
        this._util.mensajeErroToast('Ocurrió un error al buscar la garita asignada, inténtelo nuevamente.');
      }
    );
  }

  obtenerPorId(idGarita: number) {
    this.mantenimientoGaritasS.obtenerPorId(idGarita).subscribe(
      resp => {
        this.ticketAutorizacionTransporteForm.get('garitaAsignada').setValue(resp.idGarita);
        this.ticketAutorizacionTransporteForm.get('garitaAsignadaDescripcion').setValue(`${resp.desca}`);
      },
      error => {
        this._util.mensajeErroToast('Ocurrió un error al buscar la garita asignada, inténtelo nuevamente.');
      }
    );
  }

  imprimirTicket({ rowData }) {
    this.loading = true;
    console.log("rowData", rowData)
    this.ticketAutorizacionTransporteS.imprimir(rowData).subscribe(
      resp => {
        console.log("Imprimir resp", resp)
        if (resp) {
          this._util.descargarArchivo("ticket-autorización-transporte-" + rowData.idAuthTransp + ".pdf", resp);
          this.loading = false;
          return;
        }
        this._util.mensajeErroToast('No se pudo imprimir correctamente.');
        this.loading = false;
      },
      error => {
        this.loading = false;
      }
    );
  }

  buscarCliente() {
    this.ticketAutorizacionTransporteS.getCliente(
      this.ticketAutorizacionTransporteForm.get('cliente').value?.trim()
    ).subscribe(
      resp => {
        if (resp) {
          console.log("RESP CLIENTE", resp)
          this.ticketAutorizacionTransporteForm.get('clienteDetalle').setValue(`${resp.idCliente.trim()} - ${resp.nombreCliente1.trim()}`);
          return;
        }
        this.ticketAutorizacionTransporteForm.get('clienteDetalle').reset();
        this._util.mensajeErroToast('Cliente incorrecto.');
      },
      error => {
        this.ticketAutorizacionTransporteForm.get('clienteDetalle').reset();
        this._util.mensajeErroToast('Ocurrió un error inesperado, inténtelo nuevamente.');
      }
    );
  }

  buscarProveedor() {
    this.proveedorS.obtenerPorRuc(
      this.ticketAutorizacionTransporteForm.get('proveedor').value.trim()
    ).subscribe(
      resp => {
        if (resp) {
          this.ticketAutorizacionTransporteForm.get('detalleProveedor').setValue(`${resp.idProveedor.trim()} - ${resp.nombre.trim()}`);
          this.ticketAutorizacionTransporteForm.controls['proveedorId'].setValue(resp.idProveedor.trim());

          this.validaProveedorTransporte();
          return;
        }
        this.ticketAutorizacionTransporteForm.get('detalleProveedor').reset();
        this._util.mensajeErroToast('Identificación del proveedor de compra incorrecto.');
      },
      error => {
        this.ticketAutorizacionTransporteForm.get('detalleProveedor').reset();
        this._util.mensajeErroToast('Identificación del proveedor de compra incorrecto.');
      }
    );
  }

  buscarPlacaTransporte() {
    let tipoServicio = this.ticketAutorizacionTransporteForm.get('idTipoOrd').value;

    this.placaS.obtenerPorPlaca(this.ticketAutorizacionTransporteForm.get('placa').value.trim())
    .subscribe(
        resp => {
            if (resp) {
              if (tipoServicio != 4 && tipoServicio != 3) {
                 this.resetCampos();
                 this.ticketAutorizacionTransporteForm.get('proveedorTranspId').setValue(`${resp.cedula.trim()}`);
                }

              if (tipoServicio != 3) {
                 this.onChangeProveedorTransporte(event);
                }
                
              this.ticketAutorizacionTransporteForm.get('vehiculo').setValue(`${resp.tipoTransporte.trim()}`);
              this.ticketAutorizacionTransporteForm.get('marca').setValue(`${resp.marca.trim()}`);
              this.ticketAutorizacionTransporteForm.get('modelo').setValue(`${resp.modelo.trim()}`);
              
              return;
            }
            
            this._util.mensajeErroToast('La placa no contiene datos.');
          },
          error => {
            console.log(error.error.mensaje);
          }
        );

  }

  buscarCedulaChofer() {
    this.cedulaChoferS.obtenerPorCedula(
      this.ticketAutorizacionTransporteForm.get('cedula').value.trim()
    ).subscribe(
      resp => {
        if (resp) {
          console.log("CHOFER", resp)
          this.ticketAutorizacionTransporteForm.get('chofer').setValue(resp.idChofer.trim() + " - " + resp.nombres.trim());
          this.ticketAutorizacionTransporteForm.get('celular').setValue(resp.fono ? resp.fono.trim(): resp.fono);
          
          return;
        }
        this.ticketAutorizacionTransporteForm.get('chofer').reset();
        this.ticketAutorizacionTransporteForm.get('celular').reset();
        this._util.mensajeErroToast('La cédula es incorrecta.');
      },
      error => {
        this.ticketAutorizacionTransporteForm.get('chofer').reset();
        this.ticketAutorizacionTransporteForm.get('cedula').reset();
        this.ticketAutorizacionTransporteForm.get('celular').reset();
        this._util.mensajeErroToast('La cédula es incorrecta.');
      }
    );
    // searchChofer.value = 'Brayan Dummy';
  }

  obtenerTicketAutorizacionTransporte() {
    this.loading = true;
    this.rowData = [];
    this.ticketAutorizacionTransporteS.obtener().subscribe(
      (resp) => {
        resp.map(item => {
          item["estadoControlEntradaDesc"] = (item["estadoControlEntrada"] == 0) ? "SALIDA" : "INGRESADO";
          return item;
        })
        console.log("AQUIII", resp)
        this.rowData = resp;
        this.loading = false;
      },
      (error) => {
        this.rowData = [];
        this.loading = false;
      }
    );
  }

  guardarEditarTicket() {
    this.loading = true;
    if (this.ticketAutorizacionTransporteForm.invalid) return;

    let obj = this.ticketAutorizacionTransporteForm.getRawValue();
    console.log("obj", obj);
/*
    let data = {
      placa: obj.placa,
      proveedor: obj.proveedorId,
      chofer: obj.chofer,
      cedula: obj.cedula,
      estado: "ACTIVO",
      idTipoOrd: obj.idTipoOrd,
      observacion: obj.observaciones,
      fecha: obj.fecha.split(' ')[0].split('-').reverse().join('-') + 'T' + obj.fecha.split(' ')[1],
      proveedorTransp: obj.proveedorTranspId,
      estadoControlEntrada: 1,
      sellos: obj.sellos,
      cliente: obj.cliente,
      pesoBrutoRecibido: parseFloat(obj.pesoBrutoRecibido),
      fechaSalida: obj.fechaSalida ? obj.fechaSalida.split(' ')[0].split('-').reverse().join('-') + 'T' + obj.fechaSalida.split(' ')[1] : '',
      referenciaProducto: obj.referenciaProducto,
      facturaGuia: obj.facturaGuia,
      lugarSalida: obj.lugarSalida,
      lugarLlegada: obj.lugarLlegada,
      idGarita: {idGarita: obj.garitaAsignada, desca: obj.garitaAsignadaDescripcion, estado: 0},
      observaciones: obj.observaciones,
      ordenFlete: obj.ordenFlete,
    };

    if(this.modoFormulario == "Edit"){
      data['idAuthTransp'] = obj.nroAutorizacionTransporte;
      data.pesoBrutoRecibido = data.pesoBrutoRecibido ? data.pesoBrutoRecibido : 0;
    }

    console.log("data y modo", data, this.modoFormulario);
*/

    
    obj.fecha        = obj.fecha.split(' ')[0].split('-').reverse().join('-') + 'T' + obj.fecha.split(' ')[1];
    obj.fechaSalida  = obj.fechaSalida  ? obj.fechaSalida.split(' ')[0].split('-').reverse().join('-') + 'T' + obj.fechaSalida.split(' ')[1] : '';
    
    let fechaLLegada =  formatDate(obj.fechaLlegada, 'dd-MM-yyyy HH:mm:ss', 'en');
    obj.fechaLlegada  = obj.fechaLlegada  ? fechaLLegada.split(' ')[0].split('-').reverse().join('-') + 'T' + fechaLLegada.split(' ')[1] : '';

    obj.observacion  = obj.observaciones;
    obj.proveedor   = obj.proveedorId;
    obj.proveedorTransp = obj.proveedorTranspId;;
    obj.idGarita = {idGarita: obj.garitaAsignada, desca: obj.garitaAsignadaDescripcion};

    if(!this.isCreated){
      const found = this.rowData.find(item => item.idAuthTransp === obj.idAuthTransp);
      if(found != null){
        obj.idGarita = found;
      }
    }

    if(this.modoFormulario == "Edit"){
      obj.idAuthTransp = obj.nroAutorizacionTransporte;
      obj.pesoBrutoRecibido = obj.pesoBrutoRecibido ? obj.pesoBrutoRecibido : 0;
    }

    this._util.confirmarSincronoPromesa({
        title   : this.modoFormulario == "New"  ? this.DAT_MSG.procesar : this.DAT_MSG.actualizar,
        text    : this.modoFormulario == "Edit" ? obj.nroAutorizacionTransporte : "-", 
        action  : this.modoFormulario == "New"  ? this.DAT_BTNS.nuevo : this.DAT_BTNS.editar,
        funcion : this.modoFormulario == "New"  ? this.ticketAutorizacionTransporteS.crear(obj) : this.ticketAutorizacionTransporteS.editar(obj),
      }).then(() => {
        //this.obtenerTicketAutorizacionTransporte();
        this.onChangeFiltros(1);
        this.loading = false;
        this.closeModal();
      }).catch(() => {
        this.loading = false;
      });
  }

  eliminarTicket({ rowData }) {
    if (rowData.estadoControlEntrada != 1) {
      this._util.mensajeErroToast('ACCIÓN INVALIDA. TICKET YA REGISTRA SALIDA DE PLANTA');
      return;
    }

    this.loading = true;
    this._util.confirmarSincronoPromesa({
        title   : this.DAT_MSG.eliminar,
        text    : `Ticket: ${rowData.idAuthTransp}`,
        action  : this.DAT_BTNS.eliminar,
        funcion : this.ticketAutorizacionTransporteS.borrar(rowData.idAuthTransp),
      }).then((res: any) => {
        this.obtenerTicketAutorizacionTransporte();
        this.loading = false;
        this.closeModal();
      }).catch(() => {
        this.loading = false;
      });
  }

  nuevo() {
    this.isCreated = true;
    this.modoFormulario = "New";
    this.tituloModal = this.DAT_TITULOS.tituloAgregar;
    this.ticketAutorizacionTransporteForm.reset();
    this.ticketAutorizacionTransporteForm.get('idTipoOrd').enable();
    this.ticketAutorizacionTransporteForm.get('fecha').setValue(formatDate(new Date(), 'dd-MM-yyyy HH:mm:ss', 'en'));
    this.ticketAutorizacionTransporteForm.get('usuario').setValue(localStorage.getItem('userName'));
    this.usuarioBasculaGarita();
    this.openModal();
  }

  editarTicket({rowData}){
    /*if (rowData.estadoControlEntrada != 1){
      this._util.mensajeErroToast('ACCIÓN INVALIDA. TICKET YA REGISTRA SALIDA DE PLANTA');
      return;
    }*/

    this.isCreated      = false;
    this.modoFormulario = "Edit";
    this.tituloModal    = this.DAT_TITULOS.tituloActualizar;
    
    this.ticketAutorizacionTransporteForm.reset();
    this.ticketAutorizacionTransporteForm.patchValue(rowData);
    
    this.ticketAutorizacionTransporteForm.get('nroAutorizacionTransporte').setValue(rowData.idAuthTransp);
    this.ticketAutorizacionTransporteForm.get('observaciones').setValue(rowData.observacion);    
    this.ticketAutorizacionTransporteForm.get('fecha').setValue(formatDate(new Date(rowData.fecha), 'dd-MM-yyyy HH:mm:ss', 'en'));
    this.ticketAutorizacionTransporteForm.get('idTipoOrd').disable();
    this.ticketAutorizacionTransporteForm.get('usuario').setValue(rowData.usuario.trim() === '' ? localStorage.getItem('userName') : rowData.usuario);

    this.ticketAutorizacionTransporteS.obtenerPorId(rowData.idAuthTransp).subscribe(
      respTicket => {
        console.log("TICKET x ACTUALIZAR", respTicket);   

        if (respTicket) {          
          if(respTicket.proveedorTransp != null){ 
            this.ticketAutorizacionTransporteForm.get('proveedorTranspId').setValue(respTicket.proveedorTransp);

            if(this.tipoOrden.value == 3)
              this.proveeTransporteRuc.setValue(rowData.rucProvTransporte);

            /*this.proveedorS.obtenerPorId(respTicket.proveedorTransp).subscribe(
              resp => {
                this.ticketAutorizacionTransporteForm.get('proveedorTransp').setValue(resp.ruc);
                this.onChangeProveedorTransporte(Event);
              });*/
          }

          if(respTicket.proveedor != null){
            this.proveedorS.obtenerPorId(respTicket.proveedor).subscribe(
              resp => { 
                this.ticketAutorizacionTransporteForm.get('proveedor').setValue(resp.ruc);
                this.ticketAutorizacionTransporteForm.controls['proveedorId'].setValue(resp.idProveedor.trim());
                this.buscarProveedor();
              });              
          }

          if(respTicket.cliente != null){
            this.buscarCliente();
          }
          
          this.loading = false;

          this.usuarioBasculaGarita();
          this.openModal(); 
          this.buscarCedulaChofer();
          this.buscarPlacaTransporte();

          return;
        }

        this._util.mensajeErroToast('No se puede abir ticket garita');
        this.loading = false;

      }, error =>{
        this.loading = false;
      }
      
    );
    
  }

  acciones(event) {
    if (event === 'regresar') return this.closeModal();
    this.guardarEditarTicket();
    
    /*if (this.isCreated) this.guardarEditarTicket();
    if (!this.isCreated) this.guardarEditarTicket();*/
  }

  openModal() {
    document.getElementById('abrirModalAregarTicket').click();
  }

  closeModal() {
    document.getElementById('cerrarModalAgregarTicket').click();
  }

  keyAlfanumericoGuion(event: KeyboardEvent) {
    var charCode = event.which ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57))
      return false;

    return true;
  }

  keyDecimals(event: KeyboardEvent) {
    var charCode = event.which ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57))
      return false;

    return true;
  }

  getFormValidationErrors() {

    console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');

    let totalErrors = 0;

    Object.keys(this.ticketAutorizacionTransporteForm.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.ticketAutorizacionTransporteForm.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });

    console.log('Number of errors: ', totalErrors);
  }

  onChangeProveedorTransporte(event: any) {
    //this.getFormValidationErrors();
    if (event.key == " " || event.code == "Space" || event.keyCode == 32) return;
   
    this.loading    = true;
    let pTransporte = this.providerTransp.value?.trim();

    if(this.tipoOrden.value != 3){
      if(pTransporte != null){
        console.log('proveedor de transporte', pTransporte);
        this.proveedorS.obtenerPorId(pTransporte).subscribe(
          resp => {
            console.log("Proveedor de trasnporte", resp);
            this.proveedorTransporteInvalido = false;
            this.ticketAutorizacionTransporteForm.get('proveedorTransp').setValue(resp.ruc);
            this.ticketAutorizacionTransporteForm.controls['detProveedorTransporte'].setValue(resp.idProveedor + " - " + resp.nombre);
          },(error) => {
            console.log("Error", error.error.mensaje);
            this.proveedorTransporteInvalido = true;
            this._util.mensajeErroToast('Proveedor de transporte Incorrecto. Verificar existencia');
          });
        }

        this.loading  = false;

      } else{
        pTransporte = this.proveeTransporteRuc.value?.trim();

      //if (this.proveeTransporteControl.value.trim() != null && this.proveeTransporteControl.value.trim().length > 12) {
       this.proveedorS.obtenerPorRuc(pTransporte).subscribe(
          (resp) => {
            if (resp) {
              console.log("RESP PROV TRA", resp)
              this.proveedorTransporteInvalido = false;
              this.ticketAutorizacionTransporteForm.controls['detProveedorTransporte'].setValue(resp.idProveedor + " - " + resp.nombre);
              this.ticketAutorizacionTransporteForm.controls['proveedorTranspId'].setValue(resp.idProveedor.trim());
            } else {
              this.proveedorTransporteInvalido = true;
              this.ticketAutorizacionTransporteForm.controls['detProveedorTransporte'].setValue('');
              this._util.mensajeErroToast('Proveedor de transporte incorrecto.');
            }
            this.loading = false;
          },
          (error) => {
            this.loading = false;
            this.proveedorTransporteInvalido = true;
            this.ticketAutorizacionTransporteForm.controls['detProveedorTransporte'].setValue('');
            this._util.mensajeErroToast('Proveedor de transporte incorrecto.');
          }
        );

      /*}else{
        this._util.mensajeErroToast('RUC requiere 13 digitos.');
        this.loading = false;
      }*/

      }
  
    }

  onChangeTipoServicio(tipo){
    // Contratado: 1
    // Vehículo Propio: 2
    // Ocasional: 3
    // Importaciones : 4

	  if(!tipo) return;	
	  console.log('TIPO DE SERVICIO=>', tipo);

    this.proveedorTransporteInvalido = true;
    //this.ticketAutorizacionTransporteForm.get('proveedorTransp').enable();
    this.ticketAutorizacionTransporteForm.get('detProveedorTransporte').setValidators([Validators.required]);
    this.ticketAutorizacionTransporteForm.get('detProveedorTransporte').updateValueAndValidity();
    this.ticketAutorizacionTransporteForm.get('cliente').enable();
    this.ticketAutorizacionTransporteForm.get('proveedor').enable();
    this.ticketAutorizacionTransporteForm.get('proveedorTransp')?.disable({ onlySelf: true });
    this.resetCampos();

    if(tipo == 3){
      this._util.mensajeOKToast('Tipo transporte Ocasional.');
      this.ticketAutorizacionTransporteForm.get('proveedorTransp').enable();
      
      this.ticketAutorizacionTransporteForm.get('proveedorTransp').setValue("");
      this.ticketAutorizacionTransporteForm.get('proveedorTransp').setValidators([]);
      this.ticketAutorizacionTransporteForm.get('proveedorTransp').updateValueAndValidity();

      this.ticketAutorizacionTransporteForm.get('proveedorTranspId').setValue("");
      this.ticketAutorizacionTransporteForm.get('proveedorTranspId').setValidators([]);
      this.ticketAutorizacionTransporteForm.get('proveedorTranspId').updateValueAndValidity();

      this.ticketAutorizacionTransporteForm.get('detProveedorTransporte').setValue("");
      this.ticketAutorizacionTransporteForm.get('detProveedorTransporte').setValidators([]);
      this.ticketAutorizacionTransporteForm.get('detProveedorTransporte').updateValueAndValidity();
      this.proveedorTransporteInvalido = false;
    }

    if(tipo == 4){
      if(this.isCreated){
        this._util.mensajeOKToast('Seleccione Tanquero.');
      }
      this.ticketAutorizacionTransporteForm.get('cliente').disable();
      this.ticketAutorizacionTransporteForm.get('proveedor').disable();
    }

  }


  tanquerosList;
  obtenerTanqueros() {
    this.loading = true;
    this.tanqueroServices.obtener().subscribe(
      (resp) => {
        console.log('info tanquero', resp);
        this.tanquerosList = resp.filter(item => item["estado"] == 1);
        this.loading = false;
      },
      (error) => {
        this.tanquerosList = [];
        this.loading = false;
      }
    )
  }

  onChangeTanquero(event:any){
    let tanqueroSelected = this.tanquerosList.filter(item => item["idTanquero"] == event);
    console.log('Tanquero =====>', event, tanqueroSelected);
  }

  //ResetCamposdeTransporte
  resetCampos(){
    this.ticketAutorizacionTransporteForm.get('vehiculo').reset();
    this.ticketAutorizacionTransporteForm.get('marca').reset();
    this.ticketAutorizacionTransporteForm.get('modelo').reset();

    this.ticketAutorizacionTransporteForm.get('proveedorTranspId').reset();
    this.ticketAutorizacionTransporteForm.get('proveedorTransp').reset();
    this.ticketAutorizacionTransporteForm.get('detProveedorTransporte').reset();
  }

  onChangeFiltros(event: any){
    let filtro = event;
    this.loading = true;
    this.rowData = [];
    console.log("filtrar por ===>", filtro);
    this.estadoSeleccionado = event;
    this.girdComponent();

    if(event == 3){
      this.obtenerTicketAutorizacionTransporte();
      return
    }
    this.ticketAutorizacionTransporteS.getEstados(filtro).subscribe(
      (resp) => {
        resp.map(item => {
          item["estadoControlEntradaDesc"] = (item["estadoControlEntrada"] == 0) ? "SALIDA" : "INGRESADO";
          return item;
        });
        this.rowData = resp;
      },
      (error) => {
        this.rowData = [];
      }
    );   
    this.loading = false;

  }

  validaProveedorTransporte(){
    let proveedorCompra = this.ticketAutorizacionTransporteForm.get('proveedorId').value.trim();
    let mensajePantalla = "Continuar con proveedor de transporte";

    let param = {
      title : "El proveedor de Compra Ingresado es proveedor de transporte ¿Desea Continuar?",
      text  :  this.ticketAutorizacionTransporteForm.get('detalleProveedor').value,
      accion : "Consulta"
    };

    this.dmaestrosServices.getPlacabyProvedor(proveedorCompra).subscribe(
      (response) =>{
        if(response){
          Swal.fire({
            icon  : 'warning',
            title : "El proveedor de Compra Ingresado es proveedor de TRANSPORTE",
            text  : "¿Desea Continuar?",
            showCancelButton    : true,
            cancelButtonColor   : '#d33',
            confirmButtonText   : 'Si, estoy seguro'
          }).then((result) => {
            console.log("resultado", result);
            if(!result.isConfirmed){         
              this.ticketAutorizacionTransporteForm.get('proveedor').setValue("");
              this.ticketAutorizacionTransporteForm.get('detalleProveedor').reset();
              mensajePantalla = "Busca un proveedor de Compra"; 
            }              
            this._util.mensajeErrorVisto(mensajePantalla);
          });
        } 
      }, (error) => {
        return;
        console.log(error.error.mensaje);
        this._util.mensajeOKToast("No se encuentra en proveedores de transportes");
      });
  }

  
  //T.13581 GARITA EN TODAS LAS AGENCIAS 
  getTicketOrigen(){
    //this._util.mensajeOKVisto("ESte acción llenará los campos con ek Ticket Vinculado");
    let ticketOrigen = this.ticketAutorizacionTransporteForm.get('authOrigenId').value;
    console.log("Ticket de Transporte Ingresado", ticketOrigen);

    if(ticketOrigen == null){
      this._util.mensajeErrorVisto("Ingrese un valor valido para la busqueda");
    }

    this.ticketAutorizacionTransporteS.obtenerPorId(ticketOrigen)
    .subscribe(
      respTicket => {
        console.log("respuesta del ticket", respTicket);
        //this.ticketAutorizacionTransporteForm.patchValue(respTicket);
        //this.ticketAutorizacionTransporteForm.get('authOrigenId').setValue(ticketOrigen);
                //this.ticketAutorizacionTransporteForm.get('usuario').setValue(localStorage.getItem('userName'));

        this.ticketAutorizacionTransporteForm.get('observaciones').setValue(respTicket.observacion);
        this.ticketAutorizacionTransporteForm.get('fechaLlegada').reset();
        this.ticketAutorizacionTransporteForm.get('placa').setValue(respTicket.placa);
        this.ticketAutorizacionTransporteForm.get('cedula').setValue(respTicket.cedula);
        this.ticketAutorizacionTransporteForm.get('cliente').setValue(respTicket.cliente);
        this.ticketAutorizacionTransporteForm.get('proveedorId').setValue(respTicket.proveedor);
        this.ticketAutorizacionTransporteForm.get('proveedorTranspId').setValue(respTicket.proveedor);

        if(respTicket.proveedor != null){
          this.proveedorS.obtenerPorId(respTicket.proveedor).subscribe(
            resp => { 
              this.ticketAutorizacionTransporteForm.get('proveedor').setValue(resp.ruc);
              this.ticketAutorizacionTransporteForm.controls['proveedorId'].setValue(resp.idProveedor.trim());
              this.buscarProveedor();
            });              
        }
    
        if(respTicket.cliente != null){  this.buscarCliente();  }

        this.buscarCedulaChofer();
        this.buscarPlacaTransporte();
      
      }, error =>{
        this.loading = false;
      });
  }

}